// Little-endian reader for the binary model formats (MD3, MDC, MDM, MDX).

export class BinReader {
  readonly view: DataView;
  readonly bytes: Uint8Array;

  constructor(data: Uint8Array) {
    this.bytes = data;
    this.view = new DataView(data.buffer, data.byteOffset, data.byteLength);
  }

  i32 = (o: number): number => this.view.getInt32(o, true);
  u32 = (o: number): number => this.view.getUint32(o, true);
  i16 = (o: number): number => this.view.getInt16(o, true);
  f32 = (o: number): number => this.view.getFloat32(o, true);
  vec = (o: number): [number, number, number] => [this.f32(o), this.f32(o + 4), this.f32(o + 8)];

  /** NUL-terminated string in a fixed size field (MAX_QPATH = 64). */
  str(o: number, len = 64): string {
    let s = '';
    for (let i = o; i < o + len && this.bytes[i]; i++) s += String.fromCharCode(this.bytes[i]);
    return s;
  }

  ident(o = 0): string {
    return String.fromCharCode(this.bytes[o], this.bytes[o + 1], this.bytes[o + 2], this.bytes[o + 3]);
  }

  check(ident: string, versions: number[], name: string): void {
    if (this.bytes.length < 8 || this.ident() !== ident) throw new Error(`${name}: not a ${ident} file`);
    const v = this.i32(4);
    if (!versions.includes(v)) throw new Error(`${name}: ${ident} version ${v} not supported`);
  }
}

/** Surface names are lowercased with a trailing _1 / _2 removed (R_LoadMD3 / R_LoadMDC). */
export function surfaceName(name: string): string {
  const n = name.toLowerCase();
  return n.length > 2 && n[n.length - 2] === '_' ? n.slice(0, -2) : n;
}
